module.exports = __webpack_public_path__ + "img/secure_2fa.b8b88341.svg";